import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscriber, Subscription, Observable, fromEvent } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { Product } from '../interfaces/product';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';

export let browserRefresh = false;


@Component({
  selector: 'app-produits',
  templateUrl: './produits.component.html',
  styleUrls: ['./produits.component.scss']
})
export class ProduitsComponent extends WizardHpBaseComponent implements OnInit {

  public products: any;
  public prodId: any;
  subscription !: Subscription;
  searchControl = new FormControl();
  filteredOptions !: Observable<Product[]>;
  options: Product[] = [];
  p: number = 1;
  pages = [];
  pageOfItems?: Array<any>;
  ElementsByPage = 14;
  answerProgress = false;
  productSelected = false;

  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService, router: Router) {

    super(chgDetectorRef, hpService, router);

    this.products = this.getHpService().getListProducts();
    this.getHpService().setFormeId(1);
    this.getHpService().setCurrentPage(2);
   
    this.getHpService().setHeaderIn(true);
    this.getHpService().setEtape_final(false);
    this.getHpService().setPreviousPage('selecteur-maisons'); 
    this.getHpService().setCurrentPage(this.getIndexNextUrl('familles'));
   

  }

  ngOnInit() {
    if (!this.products) {
      this.getRouter().navigate([this.getHpService().getConfig().herculepro.slug]);
    }
    this.getHpService().setStatutMatButton(true);
    this.options = this.products.root.data;
    this.filteredOptions = this.searchControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.Modele),
        map(name => name ? this._filter(name) : this.options.slice())
      );


  }
  private _filter(name: string): Product[] {
    const filterValue = name.toLowerCase();
    return this.options.filter(option => option.libelle.toLowerCase().includes(filterValue));
  }
  public fetchOneProduct(prodId: any, leaf: boolean) {
    debugger;
    if (leaf) {
      this.answerProgress = true;
      this.getHpService().setListProducts(this.products);
      this.getHpService().fetchOneProduct(this.getHpService().getCatId(), prodId, true).subscribe(data => {
        this.getHpService().setGlobaldata(data);
        this.getHpService().setInitProduct(prodId);
        this.answerProgress = false;
        if (this.getHpService().getConfig().herculepro.hasDimension) {
          this.getHpService().setCurrentPage(this.getIndexNextUrl('dimensions'))
          this.getRouter().navigate(['dimensions']);
        }
        else {
          this.getHpService().setCurrentPage(this.getIndexNextUrl('simulateur-de-portes'))
          this.getRouter().navigate(['simulateur-de-portes']);
        }

        this.productSelected = true;
        this.getHpService().setStatutMatButton(false);
      });
      return;

    }
    this.getHpService().fetchSousFamilles(this.getHpService().getCatId(), this.getHpService().getParameters()).subscribe(data => {
      this.products = data;
      this.getHpService().setParameters(this.getHpService().getParameters() + "/" + data.root.data[0].id)
      if (data.root.data.length > 1) {
        this.products = data;
      }
      else {
        this.getHpService().fetchProducts(this.getHpService().getCatId(), this.getHpService().getParameters()).subscribe(data => {
          this.products = data;
        });
      }

    });

  }
}
